import CustomGenericTittleIconDataChip from "../../../../../../../components/CustomGenericTittleIconDataChip";
import {
    AccessDevicesChip,
    AccessDevicesTitle,
    IconChipDepartment, IconCustomAccess, IconDepartment, PersonChipBlack
} from "../../../../../../../components/buttons/IconButtons";
import CustomUserChip from "../../../../../../../components/CustomUserChip";
import NotInformation from "../../../../../../../components/NotInformation";
import {userListToLabelEmailPhoneValue} from "../../../../../../../Apis/functions";
import CustomMediumChip from "../../../../../../../components/CustomMediumChip";
import {POSITION_MODEL} from "../../../../../../../Helpers/PositionModel";
import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {GetCustomAccessByShiftId} from "../../../../../../../reduxToolkit/EmployeePayRoll/EmployeePayRollApi";
import {SEARCH_MODEL} from "../../../../../../../components/table/Model/TableModel";
import TableFunction from "../../../../../../../components/table/TableFunction";
import {VIEW_TYPE} from "../../../../../../../enums/ViewType";

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const RenderDetails = ({ row }) => {
    const dispatch = useDispatch();
    const [customAccess, setCustomAccess] = useState([]);

    const getData = ( page, { rowsPerPage }) =>{
        const body = SEARCH_MODEL.setObject({page, size:rowsPerPage});
        dispatch(GetCustomAccessByShiftId({ id: row.id, body: body?.pagination})).then(({payload:{data:{data}}})=>{
            setCustomAccess(data);
        });
    };

    const {
        t,
        pagination
    } = TableFunction({
        data: customAccess,
        view: VIEW_TYPE.GRID.name,
        labelRowsPerPage:'custom_access_per_page',
        fixedPagination:false,
        hasContainer: true,
        getData//New
    });

    return (
        <>
            <CustomGenericTittleIconDataChip title={`devices_access`} Icon={AccessDevicesTitle} />
            <div className='mb-5 mt-4'>
                {row?.devices?.length > 0 ? (
                        <div className={"d-flex flex-wrap gap-2"}>
                            {row?.devices.map((item) => (
                                <CustomUserChip
                                    className={"mt-0"}
                                    key={item.id}
                                    name={item.name}
                                    showAvatar={true}
                                    Icon={AccessDevicesChip}
                                />
                            ))}
                        </div>
                    ) :
                    <NotInformation card={true} text={t('no_information_shift_access')} />
                }
            </div>


            <CustomGenericTittleIconDataChip title={'departments'} Icon={IconChipDepartment} />
            <div className='mb-5 mt-4'>
                {row?.departments?.length > 0 ? (
                        <div className={"d-flex flex-wrap gap-2"}>
                            {row?.departments.map((item) => (
                                <CustomUserChip
                                    className={"mt-0"}
                                    key={item.id}
                                    name={item.name}
                                    showAvatar={true}
                                    Icon={IconDepartment}
                                    classNameIcon={"icon-color-shades-400"}
                                />
                            ))}
                        </div>
                    ) :
                    <NotInformation card={true} text={t('no_information_departments')} />
                }
            </div>


            <CustomGenericTittleIconDataChip title={'custom_access'} Icon={IconCustomAccess} />
            <div className='mb-5 mt-4'>
                {customAccess?.totalElements > 0 ? (
                    <>
                        <div className={"d-flex flex-wrap gap-2"}>
                            {userListToLabelEmailPhoneValue(customAccess.content, "id", PersonChipBlack).map((element) => (
                                <CustomMediumChip
                                    key={element.id}
                                    title={element.name}
                                    disabled={false}
                                    showAvatar={true}
                                    Icon={element.Icon}
                                    iconPosition={POSITION_MODEL.LEFT}
                                >
                                    {element?.subSection?.() && (
                                        <div className='mt-2 d-flex w-100 align-items-center align-content-center justify-content-between'>
                                            {element?.subSection?.()}
                                        </div>
                                    )}
                                </CustomMediumChip>
                            ))}
                        </div>
                        {pagination()}
                    </>

                    ) :
                    <NotInformation card={true} text={t('no_information_custom_access')} />
                }
            </div>
        </>
    );
}

export default RenderDetails;
